<div class="startbar d-print-none">
  <!--start brand-->
  <!-- <app-logo-box /> -->

  <!--start org switcher-->
  @if (showOrgSwitcher) {
    <app-org-switcher />
  }

  <div class="startbar-menu">
    <ngx-simplebar class="startbar-collapse" id="startbarCollapse">
      <div class="d-flex align-items-start flex-column w-100">
        <ul class="navbar-nav mb-auto w-100">
          @for (item of menuItems; track $index; let first = $first) {
            @if (item.isTitle) {
              <li
                class=""
                [ngClass]="!first ? 'menu-label mt-2' : 'menu-label pt-0 mt-0'"
              >
                @if (!first) {
                  <small class="label-border">
                    <div class="border_left hidden-xs"></div>
                    <div class="border_right"></div>
                  </small>
                  <span>{{ item.label }}</span>
                } @else {
                  <span>{{ item.label }}</span>
                }
              </li>
            } @else if (hasSubmenu(item)) {
              <ng-container
                *ngTemplateOutlet="
                  MenuItemWithChildren;
                  context: {
                    menu: item,
                  }
                "
              >
              </ng-container>
            } @else {
              <ng-container
                *ngTemplateOutlet="
                  MenuItem;
                  context: {
                    menu: item,
                  }
                "
              >
              </ng-container>
            }
          }
        </ul>
        <!-- <div class="update-msg text-center">
          <div
            class="d-flex justify-content-center align-items-center thumb-lg update-icon-box rounded-circle mx-auto"
          >
            <i
              class="iconoir-peace-hand h3 align-self-center mb-0 text-primary"
            ></i>
          </div>
          <h5 class="mt-3">Mannat Themes</h5>
          <p class="mb-3 text-muted">
            Temus is a high quality web applications.
          </p>
          <a
            href="javascript: void(0);"
            class="btn text-primary shadow-sm rounded-pill"
            >Upgrade your plan</a
          >
        </div> -->
      </div>
    </ngx-simplebar>
  </div>
</div>
<div class="startbar-overlay d-print-none"></div>

<ng-template #MenuItemWithChildren let-menu="menu">
  <li class="nav-item">
    <a
      class="nav-link"
      [routerLink]="menu.url"
      [ngClass]="{ active: activeMenuItems.includes(menu.key) }"
      data-bs-toggle="collapse"
      (click)="toggleMenuItem(menu, collapse)"
      role="button"
      [attr.aria-expanded]="!menu.collapsed"
      aria-controls="sidebarDashboards"
      [attr.aria-controls]="menu.key"
    >
      @if (menu.icon) {
        <i class="{{ menu.icon }} menu-icon"></i>
      }
      <span class="nav-text"> {{ menu.label }} </span>
      @if (menu.badge) {
        <span class="badge rounded text-success bg-success-subtle ms-1"
          >New</span
        >
      }
    </a>
    <div
      #collapse="ngbCollapse"
      [(ngbCollapse)]="menu.collapsed"
      class="collapse"
      id="sidebarDashboards"
    >
      <ul class="nav flex-column">
        @for (child of menu.subMenu; track child.label) {
          @if (hasSubmenu(child)) {
            <ng-container
              *ngTemplateOutlet="
                MenuItemWithChildren;
                context: {
                  menu: child,
                }
              "
            >
            </ng-container>
          } @else {
            <ng-container
              *ngTemplateOutlet="
                MenuItem;
                context: {
                  menu: child,
                }
              "
            >
            </ng-container>
          }
        }
      </ul>
    </div>
  </li>
</ng-template>

<ng-template #MenuItem let-menu="menu">
  <li
    class="nav-item"
    [ngClass]="{ active: activeMenuItems.includes(menu.key) }"
  >
    <ng-container *ngTemplateOutlet="MenuItemLink; context: { menu: menu }">
    </ng-container>
  </li>
</ng-template>
<ng-template #MenuItemLink let-menu="menu">
  <a
    class="nav-link"
    [routerLink]="menu.url"
    [ngClass]="{ active: activeMenuItems.includes(menu.key) }"
    [attr.aria-controls]="menu.key"
  >
    <span class="nav-text">{{ menu.label }}</span>
  </a>
</ng-template>
